import httpClient from "./httpClient";

export const getCareer = async () => {
  return await httpClient.get("/api/career");
};
